import { createContext } from 'react'

const asinContext = createContext()

export default asinContext
